import { render, staticRenderFns } from "./Bibliografia.vue?vue&type=template&id=1caa43a1"
import script from "./Bibliografia.vue?vue&type=script&lang=js"
export * from "./Bibliografia.vue?vue&type=script&lang=js"
import style0 from "./Bibliografia.vue?vue&type=style&index=0&id=1caa43a1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports